import { put, takeEvery } from "redux-saga/effects";
import { errorActions } from "./error.slice";

function* errorHandler({ payload }) {
	const { page, error } = yield payload;
	const message = error.response.data.message;
	yield put(errorActions.set({ page, message }));
}

export function* watchError() {
	yield takeEvery(errorActions.addError, errorHandler);
}
